module.exports = __webpack_public_path__ + "media/img/pages/companies/hewlettpackard-aaacd0f56153e9c1eac3d1521cf804dd.png";